import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import "../Login/Login.css";

const Landing = () => {
  const navigate = useNavigate();
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    if (!localStorage.getItem('Language'))
      localStorage.setItem('Language', 'EN');
    return localStorage.getItem('Language');
  });
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);

  const toggleLanguageDropdown = () => setLanguageDropdownOpen(!languageDropdownOpen);

  useEffect(() => {
    localStorage.setItem('Language', selectedLanguage);
  }, [selectedLanguage]);

  const handleLoginClick = () => {
    setIsNavigating(true);
    setTimeout(() => {
      navigate('/login');
    }, 300);
  };

  const handleCheckAvailabilityClick = () => {
    setIsNavigating(true);
    setTimeout(() => {
      navigate('/guests');
    }, 300);
  };

  return (
    <div className="login-page">
      <div className={`login-overlay ${isNavigating ? 'landing-fade-out' : ''}`}>
        <div className="landing-main-container">
          {/* Dual Cards Container */}
          <div className="landing-cards-container">
            {/* Guest Card */}
            <div className="landing-action-card landing-guest-card" onClick={handleCheckAvailabilityClick}>
              <h3 className="landing-card-title">
                {selectedLanguage === "EN" ? "Guest Access" : "Gostinski pristup"}
              </h3>
              <p className="landing-card-description">
                {selectedLanguage === "EN"
                  ? "Check availability of conference rooms and request reservations in just a couple of clicks"
                  : "Proverite raspoloživost konferencijskih sala i zatražite rezervaciju u samo par klikova"}
              </p>
              <div className="landing-card-button">
                <span>{selectedLanguage === "EN" ? "Check Availability" : "Proveri raspoloživost"}</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>

            {/* Staff/Internal Card */}
            <div className="landing-action-card landing-staff-card" onClick={handleLoginClick}>
              <h3 className="landing-card-title">
                {selectedLanguage === "EN" ? "Internal Access" : "Interni pristup"}
              </h3>
              <p className="landing-card-description">
                {selectedLanguage === "EN"
                  ? "Access your private account"
                  : "Pristupite vašem privatnom nalogu"}
              </p>
              <div className="landing-card-button">
                <span>{selectedLanguage === "EN" ? "Login" : "Uloguj se"}</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dropdown
        isOpen={languageDropdownOpen}
        toggle={toggleLanguageDropdown}
        style={{
          position: "fixed",
          bottom: "10px",
          right: "10px",
          zindex: "1000"
        }}
      >
        <DropdownToggle caret className="lang-toggle">
          {selectedLanguage}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => setSelectedLanguage('EN')}>EN</DropdownItem>
          <DropdownItem onClick={() => setSelectedLanguage('RS')}>RS</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default Landing;